module.exports = __webpack_public_path__ + "assets/instagram-color.d9704a04.svg";